import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard-view" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-red-700 dark:text-red-300" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8" }
const _hoisted_7 = { class: "card p-4 sm:p-6 relative flex flex-col min-h-[140px]" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = { class: "ml-5 w-0 flex-1" }
const _hoisted_11 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_12 = { class: "mt-auto pt-4" }
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = { class: "flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-3 py-1.5 border border-green-200 dark:border-green-800" }
const _hoisted_15 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_16 = { class: "flex items-center rounded-md bg-red-50 dark:bg-red-900/20 px-3 py-1.5 border border-red-200 dark:border-red-800" }
const _hoisted_17 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_18 = { class: "card p-4 sm:p-6 relative flex flex-col min-h-[140px]" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "flex-shrink-0" }
const _hoisted_21 = { class: "ml-5 w-0 flex-1" }
const _hoisted_22 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_23 = { class: "mt-auto pt-4" }
const _hoisted_24 = { class: "flex flex-wrap gap-2" }
const _hoisted_25 = { class: "flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-3 py-1.5 border border-green-200 dark:border-green-800" }
const _hoisted_26 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_27 = { class: "flex items-center rounded-md bg-blue-50 dark:bg-blue-900/20 px-3 py-1.5 border border-blue-200 dark:border-blue-800" }
const _hoisted_28 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_29 = { class: "flex items-center rounded-md bg-gray-50 dark:bg-gray-900/20 px-3 py-1.5 border border-gray-200 dark:border-gray-800" }
const _hoisted_30 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_31 = { class: "card p-4 sm:p-6 relative flex flex-col min-h-[140px]" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "flex-shrink-0" }
const _hoisted_34 = { class: "ml-5 w-0 flex-1" }
const _hoisted_35 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_36 = { class: "mt-auto pt-4" }
const _hoisted_37 = { class: "flex flex-wrap gap-2" }
const _hoisted_38 = { class: "flex items-center rounded-md bg-green-50 dark:bg-green-900/20 px-3 py-1.5 border border-green-200 dark:border-green-800" }
const _hoisted_39 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_40 = { class: "flex items-center rounded-md bg-red-50 dark:bg-red-900/20 px-3 py-1.5 border border-red-200 dark:border-red-800" }
const _hoisted_41 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_42 = { class: "flex items-center rounded-md bg-yellow-50 dark:bg-yellow-900/20 px-3 py-1.5 border border-yellow-200 dark:border-yellow-800" }
const _hoisted_43 = { class: "text-xs text-primary-text dark:text-primary-dark-text font-semibold" }
const _hoisted_44 = { class: "card p-6 mb-8" }
const _hoisted_45 = { class: "flex items-center justify-between" }
const _hoisted_46 = { class: "text-xl font-semibold text-primary-text dark:text-primary-dark-text mb-2" }
const _hoisted_47 = { class: "hidden md:block" }
const _hoisted_48 = { class: "mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" }
const _hoisted_49 = { class: "flex flex-col stack-until-1665 gap-6" }
const _hoisted_50 = { class: "card p-6 flex flex-col flex-1 h-[1120px]" }
const _hoisted_51 = { class: "flex items-center justify-between mb-4" }
const _hoisted_52 = { class: "text-xl font-semibold text-primary-text dark:text-primary-dark-text flex items-center gap-2" }
const _hoisted_53 = ["title"]
const _hoisted_54 = { class: "flex items-center gap-2" }
const _hoisted_55 = {
  key: 0,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_56 = { class: "text-center py-8" }
const _hoisted_57 = {
  key: 1,
  class: "flex-1 max-h-[70rem] overflow-y-auto space-y-3 pr-2 recent-activities-container pt-3"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 0,
  class: "activity-status-badge absolute top-3 right-3 z-10"
}
const _hoisted_60 = {
  key: 1,
  class: "absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse",
  title: "New"
}
const _hoisted_61 = { class: "activity-icon flex-shrink-0" }
const _hoisted_62 = { class: "activity-content flex-1 min-w-0" }
const _hoisted_63 = { class: "flex items-start justify-between gap-2 mb-1.5" }
const _hoisted_64 = { class: "flex-1 min-w-0" }
const _hoisted_65 = { class: "activity-name font-semibold text-primary-text dark:text-primary-dark-text text-sm leading-tight" }
const _hoisted_66 = { class: "activity-email text-xs text-secondary-text dark:text-secondary-dark-text mt-0.5 truncate" }
const _hoisted_67 = { class: "flex items-center gap-2 mt-1.5 mb-2" }
const _hoisted_68 = { class: "activity-time flex-shrink-0 text-xs text-secondary-text dark:text-secondary-dark-text flex items-center gap-1" }
const _hoisted_69 = { class: "activity-description flex items-start gap-2" }
const _hoisted_70 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text leading-relaxed" }
const _hoisted_71 = { class: "card p-6 flex-1 flex flex-col" }

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useTitle } from '@/composables/ui/useTitle'
import { useUser } from '@/composables/auth/useUser'
import { dashboardApi, type DashboardStats, type Activity } from '@/services/dashboard'
import ModuleRotationCalendar from '@/components/ModuleRotationCalendar.vue'
import { LoadingState } from '@/components/common'
import { useActivityPolling, type ActivityWithReadStatus } from '@/composables/notifications/useActivityPolling'
import {
  XCircle,
  Users,
  Archive,
  CheckCircle,
  Clock,
  LayoutDashboard,
  FileText,
  Award,
  ClipboardList,
  UserPlus,
  CalendarCheck,
  AlertCircle,
  PlayCircle,
  RefreshCw
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDashboardView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')
useTitle(`Dashboard - ${appTitle.value}`)

// Composables
const { userName } = useUser()

const router = useRouter()

// State
const loading = ref(true)
const error = ref<string | null>(null)
const stats = ref<DashboardStats>({
  totalModules: 0,
  totalEmployees: 0,
  totalExams: 0,
  passedExams: 0,
  failedExams: 0,
  skippedExams: 0,
  totalModuleAssignments: 0,
  completedModuleAssignments: 0,
  inProgressModuleAssignments: 0,
  notStartedModuleAssignments: 0,
  currentExams: 0,
  upcomingExams: 0,
  activeEmployees: 0,
  inactiveEmployees: 0
})
const recentActivity = ref<Activity[]>([])

// Activity polling with notifications
const {
  activities: polledActivities,
  unreadActivitiesCount,
  clearNewActivitiesCount,
  markAsRead,
  markAllAsRead,
  refresh: refreshActivities
} = useActivityPolling({
  enableToasts: false,
  autoStart: true,
  isAdmin: true
})

// Use polled activities as the source of truth
const displayActivities = computed<ActivityWithReadStatus[]>(() => {
  if (polledActivities.value.length > 0) {
    return polledActivities.value
  }
  // Fallback to recentActivity with default read status
  return recentActivity.value.map(activity => ({
    ...activity,
    isRead: false,
    isNew: false
  }))
})

// Methods
const fetchDashboardData = async () => {
  try {
    loading.value = true
    error.value = null

    // Fetch dashboard statistics
    const dashboardStats = await dashboardApi.getStats()
    stats.value = dashboardStats

    // Fetch recent activity
    const activity = await dashboardApi.getRecentActivity()
    recentActivity.value = activity
  } catch (err) {
    error.value = 'Failed to load dashboard data. Please try again.'
    console.error('Dashboard data fetch error:', err)
  } finally {
    loading.value = false
  }
}

const formatDate = (timestamp: string) => {
  const date = new Date(timestamp)
  const now = new Date()
  const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60))

  if (diffInHours < 1) {
    return 'Just now'
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
  } else {
    const diffInDays = Math.floor(diffInHours / 24)
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
  }
}

function extractEmail(description: string): string {
  // Match email pattern in the description
  const match = description.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)
  return match ? match[0] : ''
}

/**
 * Get the appropriate icon for the activity type
 */
function getActivityIcon(type: string, status?: string) {
  switch (type) {
    case 'user_registration':
      return UserPlus
    case 'module_assignment':
      return CalendarCheck
    case 'exam_result':
      return status === 'passed' ? Award : AlertCircle
    case 'module_start':
      return PlayCircle
    case 'module_completion':
      return CheckCircle
    default:
      return FileText
  }
}

/**
 * Get the icon background color classes
 */
function getActivityIconBg(type: string, status?: string) {
  switch (type) {
    case 'user_registration':
      return 'bg-blue-100 dark:bg-blue-900/30'
    case 'module_assignment':
      return 'bg-purple-100 dark:bg-purple-900/30'
    case 'exam_result':
      return status === 'passed' 
        ? 'bg-green-100 dark:bg-green-900/30' 
        : 'bg-red-100 dark:bg-red-900/30'
    case 'module_start':
      return 'bg-purple-100 dark:bg-purple-900/30'
    case 'module_completion':
      return 'bg-blue-100 dark:bg-blue-900/30'
    default:
      return 'bg-gray-100 dark:bg-gray-900/30'
  }
}

/**
 * Get the icon color classes
 */
function getActivityIconColor(type: string, status?: string) {
  switch (type) {
    case 'user_registration':
      return 'text-blue-600 dark:text-blue-400'
    case 'module_assignment':
      return 'text-purple-600 dark:text-purple-400'
    case 'exam_result':
      return status === 'passed' 
        ? 'text-green-600 dark:text-green-400' 
        : 'text-red-600 dark:text-red-400'
    case 'module_start':
      return 'text-purple-600 dark:text-purple-400'
    case 'module_completion':
      return 'text-blue-600 dark:text-blue-400'
    default:
      return 'text-gray-600 dark:text-gray-400'
  }
}

/**
 * Get status badge classes
 */
function getStatusBadgeClass(status: string) {
  switch (status) {
    case 'passed':
      return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800'
    case 'failed':
      return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800'
    case 'in_progress':
      return 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-800'
    case 'completed':
      return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800'
    case 'assigned':
      return 'bg-indigo-100 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 border border-indigo-200 dark:border-indigo-800'
    case 'user_registered':
      return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800'
    default:
      return 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-800'
  }
}

/**
 * Capitalize the first letter of status strings like 'passed'/'failed'
 */
function capitalizeStatus(status: string): string {
  if (!status) return ''
  // Special-case statuses with underscores for prettier display
  if (status === 'in_progress') return 'In Progress'
  if (status === 'user_registered') return 'Registered'
  return status.charAt(0).toUpperCase() + status.slice(1)
}

/**
 * Determine an activity status to display.
 * If the activity has an explicit status use it; for module_assignment default to 'assigned'.
 */
function getActivityStatus(activity: Activity | any): string {
  if (!activity) return ''
  if (activity.status) return activity.status
  if (activity.type === 'module_assignment') return 'assigned'
  if (activity.type === 'user_registration') return 'user_registered'
  return ''
}

/**
 * Get a cleaner activity description
 */
function getActivityDescription(activity: Activity): string {
  const { type, description } = activity
  
  switch (type) {
    case 'user_registration':
      return 'Registered as a new employee'
    case 'module_assignment': {
      // Extract the year and months from description
      const match = description.match(/assigned training for (\d{4}) \((.*?)\)/)
      if (match) {
        return `Assigned training modules for ${match[1]}`
      }
      return 'Assigned training modules'
    }
    case 'exam_result': {
      // Extract module name from description
      const moduleMatch = description.match(/exam for (.+)$/)
      if (moduleMatch) {
        return `Completed exam: ${moduleMatch[1]}`
      }
      return 'Completed an exam'
    }
    default:
      return description
  }
}

/**
 * Navigate to certificates route if it exists, otherwise fallback to profile.
 */
function navigateToCertificates() {
  const hasCertificatesRoute = router.getRoutes().some(r => r.name === 'certificates' || r.path === '/certificates')
  if (hasCertificatesRoute) {
    router.push({ name: 'certificates' }).catch(noop)
  } else {
    // Fallback: navigate to profile if specific certificates route not implemented
    router.push({ name: 'Profile' }).catch(noop)
  }
}

/**
 * Handle refresh activities and mark as viewed
 */
const handleRefreshActivities = async () => {
  await refreshActivities()
  clearNewActivitiesCount()
}

// Handle activity click - mark as read
const handleActivityClick = (activity: any) => {
  if (!activity.isRead) {
    markAsRead(activity.id)
  }
}

// Handle mark all as read
const handleMarkAllAsRead = () => {
  markAllAsRead()
  clearNewActivitiesCount()
}

function noop() {
  /* intentionally empty */
}

// Lifecycle
onMounted(() => {
  fetchDashboardData()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text mb-2" }, " Dashboard "),
      _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Welcome back! Here's an overview of your account and activities. ")
    ], -1)),
    _createVNode(_unref(LoadingState), {
      "is-loading": loading.value,
      type: "dashboard",
      text: "Loading dashboard..."
    }, null, 8, ["is-loading"]),
    (!loading.value && error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(XCircle), { class: "w-5 h-5 text-red-500 mr-2" }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(error.value), 1)
          ]),
          _createElementVNode("button", {
            onClick: fetchDashboardData,
            class: "mt-2 text-sm text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 underline"
          }, " Try again ")
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(Users), { class: "w-8 h-8 text-blue-500" })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("dl", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text truncate" }, " Total Employees ", -1)),
                    _createElementVNode("dd", _hoisted_11, _toDisplayString(stats.value.totalEmployees || 0), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(CheckCircle), { class: "w-4 h-4 text-green-600 dark:text-green-400 mr-1.5 flex-shrink-0" }),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-xs text-green-700 dark:text-green-300 font-medium mr-1" }, "Active:", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(stats.value.activeEmployees || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 text-red-600 dark:text-red-400 mr-1.5 flex-shrink-0" }),
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs text-red-700 dark:text-red-300 font-medium mr-1" }, "Inactive:", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(stats.value.inactiveEmployees || 0), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_unref(ClipboardList), { class: "w-8 h-8 text-purple-500" })
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("dl", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text truncate" }, " Module Progress ", -1)),
                    _createElementVNode("dd", _hoisted_22, _toDisplayString(stats.value.totalModuleAssignments || 0), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_unref(CheckCircle), { class: "w-4 h-4 text-green-600 dark:text-green-400 mr-1.5 flex-shrink-0" }),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-xs text-green-700 dark:text-green-300 font-medium mr-1" }, "Completed:", -1)),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(stats.value.completedModuleAssignments || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_unref(Clock), { class: "w-4 h-4 text-blue-600 dark:text-blue-400 mr-1.5 flex-shrink-0" }),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-xs text-blue-700 dark:text-blue-300 font-medium mr-1" }, "In Progress:", -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(stats.value.inProgressModuleAssignments || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 text-gray-600 dark:text-gray-400 mr-1.5 flex-shrink-0" }),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-xs text-gray-700 dark:text-gray-300 font-medium mr-1" }, "Not Started:", -1)),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(stats.value.notStartedModuleAssignments || 0), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_unref(Archive), { class: "w-8 h-8 text-green-500" })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("dl", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("dt", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text truncate" }, " Total Exams ", -1)),
                    _createElementVNode("dd", _hoisted_35, _toDisplayString(stats.value.totalModules || 0), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_unref(CheckCircle), { class: "w-4 h-4 text-green-600 dark:text-green-400 mr-1.5 flex-shrink-0" }),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-xs text-green-700 dark:text-green-300 font-medium mr-1" }, "Passed:", -1)),
                    _createElementVNode("span", _hoisted_39, _toDisplayString(stats.value.passedExams || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_unref(XCircle), { class: "w-4 h-4 text-red-600 dark:text-red-400 mr-1.5 flex-shrink-0" }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-xs text-red-700 dark:text-red-300 font-medium mr-1" }, "Failed:", -1)),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(stats.value.failedExams || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_unref(Clock), { class: "w-4 h-4 text-yellow-600 dark:text-yellow-400 mr-1.5 flex-shrink-0" }),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-xs text-yellow-700 dark:text-yellow-300 font-medium mr-1" }, "Skipped:", -1)),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(stats.value.skippedExams || 0), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_46, " Welcome, " + _toDisplayString(_unref(userName)) + "! ", 1),
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " You're logged in as an Admin. Here's what you can do: ", -1))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_unref(LayoutDashboard), { class: "w-16 h-16 text-primary/20" })
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_router_link, {
                to: "/employee",
                class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg hover:shadow transition-shadow",
                "aria-label": "Manage Employees"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Users), { class: "w-6 h-6 text-primary mr-3" }),
                  _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "font-medium text-primary-text dark:text-primary-dark-text" }, " Manage Employees "),
                    _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, " Add and manage employees ")
                  ], -1))
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/module",
                class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg hover:shadow transition-shadow",
                "aria-label": "Manage Modules"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Archive), { class: "w-6 h-6 text-primary mr-3" }),
                  _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "font-medium text-primary-text dark:text-primary-dark-text" }, " Manage Modules "),
                    _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, " Create and manage training materials ")
                  ], -1))
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/exam",
                class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg hover:shadow transition-shadow",
                "aria-label": "Manage Exams"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ClipboardList), { class: "w-6 h-6 text-primary mr-3" }),
                  _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "font-medium text-primary-text dark:text-primary-dark-text" }, "Manage Exams"),
                    _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, " Create and manage assessments ")
                  ], -1))
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "button",
                onClick: navigateToCertificates,
                class: "flex items-center p-4 bg-primary-bg/10 dark:bg-primary-dark-bg/10 rounded-lg hover:shadow transition-shadow w-full text-left",
                "aria-label": "Manage Certificates"
              }, [
                _createVNode(_unref(Award), { class: "w-6 h-6 text-primary mr-3" }),
                _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "font-medium text-primary-text dark:text-primary-dark-text" }, " Manage Certificates "),
                  _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, " Issue and manage certifications ")
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h2", _hoisted_52, [
                  _cache[16] || (_cache[16] = _createTextVNode(" Recent Activities ", -1)),
                  (_unref(unreadActivitiesCount) > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-bold bg-blue-500 text-white",
                        title: `${_unref(unreadActivitiesCount)} unread activit${_unref(unreadActivitiesCount) > 1 ? 'ies' : 'y'}`
                      }, _toDisplayString(_unref(unreadActivitiesCount)), 9, _hoisted_53))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  (_unref(unreadActivitiesCount) > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: handleMarkAllAsRead,
                        class: "px-3 py-1.5 text-xs font-medium text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors",
                        title: "Mark all as read"
                      }, " Mark all read "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: handleRefreshActivities,
                    class: "p-2 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors",
                    title: "Refresh activities"
                  }, [
                    _createVNode(_unref(RefreshCw), { class: "w-5 h-5 text-blue-600 dark:text-blue-400" })
                  ])
                ])
              ]),
              (displayActivities.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_unref(FileText), { class: "w-12 h-12 text-gray-400 mx-auto mb-4" }),
                      _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " No recent activities ", -1))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayActivities.value, (activity) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: activity.id,
                        onClick: ($event: any) => (handleActivityClick(activity)),
                        class: _normalizeClass([
                // add right padding so absolutely-positioned status badge doesn't overlap text
                'activity-item flex items-start gap-3 p-4 pr-12 rounded-lg shadow-sm border transition-all group cursor-pointer relative',
                activity.isRead
                  ? 'bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700 hover:shadow-md hover:border-gray-200 dark:hover:border-gray-600'
                  : 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900/30 border-l-4 border-l-blue-500'
              ])
                      }, [
                        ((activity.status || activity.type === 'module_assignment' || activity.type === 'user_registration') && (activity.type === 'exam_result' || activity.type === 'module_start' || activity.type === 'module_completion' || activity.type === 'module_assignment' || activity.type === 'user_registration'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createElementVNode("span", {
                                class: _normalizeClass([ 'flex items-center px-2 py-0.5 rounded-full text-xs font-medium', getStatusBadgeClass(getActivityStatus(activity)) ])
                              }, _toDisplayString(capitalizeStatus(getActivityStatus(activity))), 3)
                            ]))
                          : _createCommentVNode("", true),
                        (activity.isNew && !activity.isRead)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                    'w-10 h-10 rounded-full flex items-center justify-center transition-colors',
                    getActivityIconBg(activity.type, activity.status)
                  ])
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(getActivityIcon(activity.type, activity.status)), {
                              class: _normalizeClass(['w-5 h-5', getActivityIconColor(activity.type, activity.status)])
                            }, null, 8, ["class"]))
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("p", _hoisted_65, [
                                (activity.first_name && activity.last_name)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(activity.first_name) + " " + _toDisplayString(activity.last_name), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(extractEmail(activity.description)), 1)
                                    ], 64))
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_66, _toDisplayString(activity.email || extractEmail(activity.description)), 1),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("span", _hoisted_68, [
                              _createVNode(_unref(Clock), { class: "w-3.5 h-3.5" }),
                              _createTextVNode(" " + _toDisplayString(formatDate(activity.timestamp)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("p", _hoisted_70, _toDisplayString(getActivityDescription(activity)), 1)
                          ])
                        ])
                      ], 10, _hoisted_58))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createVNode(ModuleRotationCalendar, { class: "flex-1" })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})